<main class="main">
  <nav class="sidebarLeft sidebar gray-100">
    <div class="nav-fixed">
      <div class="sidebar-sticky">
        <div class="proj-sidebar-info">
          <span *ngIf="!isNSI" class="icon-left text-secondary"></span>
          <a *ngIf="!isNSI" [routerLink]="[destinoRouter]" aria-label="Voltar para trás"><span>{{'Workflow.Back' | translate}}</span></a>
          <div class="mt-3">
            <label for="workflowCode">
              {{ workflowTemplate.workflowCodeCGA }}
            </label>
            <h1>
              {{ workflowTemplate.title }}
            </h1>
            <p class="text-secondary">
              {{ workflowTemplate.subtitle }}
            </p>
            <a href="" aria-label="Link para ajuda" (click)="workflowTemplate.workFlowHelpLink && getInstructions()" class="card-link" referrerpolicy="origin">
              {{'Workflow.Instructions' | translate}}
            </a>
            <div class="text-end mt-4 d-sm-none d-md-block">
              <progressbar [value]="1 - currentPercentage" [max]="1"></progressbar>
              <small class="text-muted"> {{'Workflow.Missing' | translate}} {{currentPercentage | percent }}</small>
            </div>
          </div>
          <hr />
        </div>

        <div class="proj-sidebar-menu-scroll">
          <div class="list-group proj-sidebar-menu" *ngFor="let step of steps">
            <a class="list-group-item list-group-item-action" (click)="menuSideBarClick(step.stepCode, true, step.stateCode)"
               [ngClass]="{'active': step.stepCode == currentStep?.currentStepCode, 'porvalidar': (step.stateCode != 'V' && step.stateCode != 'MI')}"
               role="button" >
              <span>
                {{ step.title}}
              </span>
              <i class="{{ step.stateCode | toIcon }} {{step.stateCode | toIconClass}}"></i>
            </a>
          </div>
        </div>

      </div>
      <div class="proj-sidebar-navegation" *ngIf="!isWorkflowSubmited && iCanAccess">
        <button aria-label="Salvar" type="button" class="btn btn-primary" (click)="onSaveWorkflowData($event)" id="wf-save-button"
                name="wf-save-button" visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowEditPage.SaveData"
                *ngIf="!isAtendimento">
          <span class="icon-save"></span><span>{{'Workflow.Save' | translate}}</span>
        </button>
        <button *ngIf="!isWorkflowOnSubscriber " aria-label="Apagar" type="button" class="btn btn-outline-primary mt-3"
                (click)="onDeleteWorkflowData($event)" id="wf-delete-button"
                name="wf-delete-button" visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowEditPage.DeleteData">
          <span class="icon-trash"></span><span>{{'Workflow.Delete' | translate}}</span>
        </button>
        <button aria-label="Terminar" type="button" class="btn btn-outline-primary mt-3"
                *ngIf="canApagarCTO"
                (click)="onDeleteWorkflow($event,wfSubmitButton)" id="wf-terminate-button"
                name="wf-terminate-button" visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowEditPage.DeleteData">
          <span class="icon-close"></span><span>{{'Workflow.Terminate' | translate}}</span>
        </button>
        <button type="button" class="btn btn-outline-primary mt-3"
                visualActionUnauthorized action="{{VisualActions.hide}}"
                permission="WorkflowEditPage.ReturnData"
                aria-label="Devolver Pedido" (click)="onRedirect()" id="wf-return-button"
                name="wf-return-button" [hidden]="isLastStep">
          <span class="icon-close"></span>
          <span>{{'Workflow.ReturnRequestAnyTime' | translate}}</span>
        </button>
      </div>
    </div>
  </nav>
  <div class="wrapper">
    <div class="container">
      <div *ngIf="!!workflowInstance">
        <alert></alert>
        <form name="cgaWorkflowForm" #cgaWorkflowForm="ngForm">
          <fieldset visualActionUnauthorized action="{{VisualActions.disable}}" permission="WorkflowEditPage.EditData">
            <fieldset [disabled]="isWorkflowSubmited">
              <div *ngIf="!isLastStep && workflowInstanceLoaded && isCurrentStepLoaded" class="form-group text-secondary ft-sz-12">
                <label *ngIf="currentStep.currentStepCode === 'StepMap' && isWorkflowOnSubscriber === false" style="display:block">
                  O mapa de efetividade é preenchido com a informação registada nos sistemas da CGA, e para os períodos de serviço com datas
                  superiores a 2003.01.01 assumiu-se no seu pré-preenchimento os valores “Efetuou descontos” = “SIM” e “Aumento de tempo”
                  = “Não”.<br />
                  Caso a informação apresentada não se encontre correta, proceda à sua retificação, adicionando os períodos de carreira
                  contributiva em falta, ou alterando a informação nos períodos pré-preenchidos.
                </label>
                <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
              </div>

              <router-outlet></router-outlet>
            </fieldset>
          </fieldset>
          <div *ngIf="workflowInstanceLoaded && isCurrentStepLoaded" class="d-flex justify-content-between mt-4 mb-50" role="group" aria-label="Botões de Navegação">
            <button type="button" aria-label="Retroceder" class="btn btn-outline-primary" (click)="onStepBefore()" id="wf-before-button"
                    name="wf-before-button" [disabled]="isNextDisabled ? isNextDisabled : (!steps || isFirstStep)">
              <span class="icon-left"></span>
              <span>{{(isReturn ? 'Workflow.Cancel' : 'Workflow.Before') | translate}}</span>
            </button>
            <button type="button" aria-label="Próximo" class="btn btn-primary" (click)="onStepNext()" id="wf-next-button" name="wf-next-button"
                    *ngIf="!isLastStep" [disabled]="isNextDisabled">

              <span>{{'Workflow.Next' | translate}}</span>
              <span class="icon-right"></span>
            </button>
              <button type="button" class="btn btn-primary" aria-label="Submeter pedido" (click)="onSubmit($event,wfSubmitButton)" id="wf-submit-button"
                      name="wf-submit-button" *ngIf="isLastStep && !isWorkflowSubmited"
                      #wfSubmitButton
                      visualActionUnauthorized action="{{VisualActions.disable}}" permission="WorkflowEditPage.SubmitData">
                <span class="icon-send"></span>
                <span>{{(showReturnButton ? 'Workflow.ReturnRequest' : 'Workflow.SendRequest') | translate}}</span>
              </button>
</div>
        </form>
      </div>
    </div>
  </div>
  <aside>
    <subscriber-info subscriberNumber="{{workflowInstance.subscriberNumber}}" [workflowCode]="workflowInstance.workflowCode" instanceId="{{workflowInstanceId}}" [displaySubscriberInfo]="!isWorkflowOnSubscriber"></subscriber-info>
  </aside>
</main>
<!-- FORM FAKE -->
<form id="formGetFile" #cgaGetFileForm="ngForm" name="formGetFile" method="POST" target="_blank" referrerpolicy="origin">
  <input type="hidden" name="h_queryParams" id="h_queryParams" value="{{workflowTemplate.workFlowHelpLink}}">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>
<!--<pre>{{workflowInstance.formData | json}}</pre>-->

<ng-template #errorsFound>
  <div class="modal-header">
    <h5 class="modal-title text-danger d-flex align-items-center">
      <span class="icon-error mr-2 ft-sz-24"></span>
      {{'Workflow.ErrorsModalTitle' | translate}}
    </h5>
    <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body">
    {{'Workflow.ErrorsModalText1' | translate}}
    <br>
    {{'Workflow.ErrorsModalText2' | translate}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Rejeitar" (click)="modalRef.hide()"><span class="icon-check"></span><span>Ok</span></button>
  </div>
</ng-template>
